import { render, staticRenderFns } from "./Hidangan.vue?vue&type=template&id=230156df&"
import script from "./Hidangan.vue?vue&type=script&lang=js&"
export * from "./Hidangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports